document.addEventListener("DOMContentLoaded", function () {
  initImageSizer();
  initVideoSlider();
  initPromoVideo();
  initModuleVideo();
  initPriorOffCanvas();
  customCookieBar();
});


function customCookieBar() {
	if ( $('.cookie-bar').length > 0 ) {
		if ( !Cookies.get('accepted_cookies') ) {
			$('.cookie-bar').fadeIn();
		}


		$('.cookie-bar__accept').on('click', function () {
			Cookies.set('accepted_cookies', 'true', {expires: 30});
			$('.cookie-bar').fadeOut();
		});
	}
}

function initImageSizer() {
  var images = document.querySelectorAll(".auto-sizing");
  if (images.length === 0) return;
  images.forEach(function (img) {
    var windowWidth = window.innerWidth;
    var imgWidth = img.clientWidth;
    var imgViewportWidth = Math.floor((imgWidth / windowWidth) * 100) + "vw";
    img.sizes = imgViewportWidth;
  });
}

function initVideoSlider() {
  var video = document.querySelector(".slider__video iframe");
  if (!video) return;
  coverViewport(video, true);
  window.addEventListener("resize", function () {
    coverViewport(video, true);
  });


  function coverViewport(element, scaleToParent) {
    if (typeof scaleToParent === "undefined") {
      scaleToParent = false;
    }

    var viewportWidth, viewportHeight;
    if (scaleToParent) {
      viewportWidth = element.parentElement.clientWidth;
      viewportHeight = element.parentElement.clientHeight;
    } else {
      viewportWidth = window.innerWidth;
      viewportHeight = window.innerHeight;
    }

    var elementWidth = element.getAttribute("width");
    var elementHeight = element.getAttribute("height");

    // Aspect ratio = height / width
    var viewportRatio = viewportHeight / viewportWidth;
    var videoRatio = elementHeight / elementWidth;

    // console.log('viewportHeigt: ', viewportHeight )
    // console.log('viewportWidth: ', viewportWidth )
    // console.log('Viewport: ', viewportRatio, ' Video: ', videoRatio);

    var newWidth = (elementWidth / elementHeight) * viewportHeight;
    var newHeight = (elementHeight / elementWidth) * viewportWidth;
    var newTop = 0;

    if (viewportRatio > videoRatio) {
      // set video height to the viewport, and extend the video beyond the viewport width, i.e. portrait viewport
      // console.log('crop left and right');
      element.style.height = viewportHeight + "px";
      element.style.width = newWidth + "px";
      element.style.left = "-" + (newWidth - viewportWidth) / 2 + "px";
      element.style.top = "0";
    } else if (viewportRatio < videoRatio) {
      // set video width to the viewport, and extend the video beyond the viewport height, i.e. landscape viewport
      // console.log('crop top and bottom');
      element.style.width = viewportWidth + "px";
      element.style.height = newHeight + "px";
      element.style.left = "0";
      element.style.top = "-" + (newHeight - viewportHeight) / 2 + "px";
    } else {
      // set the video width AND height to the viewport size, i.e. viewport is the same ratio as the video
      // console.log('no crop');
      element.style.height = viewportHeight + "px";
      element.style.width = viewportWidth + "px";
      element.style.left = "0";
      element.style.top = "0";
    }
  }

  // Make sure the slider always fills the whole screen
  var $videoIframe = $('.slider__video iframe');
  var $sliderContainer = $('.slider');
  var $loadingElement = $(".slider__loading"); 
  var $playButton = $('.slider__video-control-btn--play');
  var $pauseButton = $('.slider__video-control-btn--pause');
  var hasVimeoControlsInitialized = false;

  $sliderContainer
    .off('mouseenter.videoHover mouseleave.videoHover')
    .on('mouseenter.videoHover', function () {
      $(this).addClass('mouse-over-video');
    })
    .on('mouseleave.videoHover', function () {
      $(this).removeClass('mouse-over-video');
    });

  function setVideoControlState(isPlaying) {
    $playButton.attr('aria-pressed', isPlaying ? 'false' : 'true');
    $pauseButton.attr('aria-pressed', isPlaying ? 'true' : 'false');
    $playButton.toggleClass('active', !isPlaying);
    $pauseButton.toggleClass('active', isPlaying);
  }
  

  function ensureVimeoApi(callback) {
    if (window.Vimeo && window.Vimeo.Player) {
      callback();
      return;
    }

    var existingScript = document.querySelector('script[data-vimeo-player-api="true"]');
    if (existingScript) {
      existingScript.addEventListener('load', callback);
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    script.setAttribute('data-vimeo-player-api', 'true');
    script.addEventListener('load', callback);
    document.body.appendChild(script);
  }
  if ($('.slider__video iframe').length > 0) {
    $('.slider__inner').on('setPosition', function () {
      coverViewport($videoIframe, true);
    });

    $('.slider__inner').on('init', function () {
      coverViewport($videoIframe, true);
    });
  }

  function initVimeoControls() {
    if (hasVimeoControlsInitialized) {
      return;
    }

    if (!$videoIframe.length || !(window.Vimeo && window.Vimeo.Player)) {
      return;
    }

    hasVimeoControlsInitialized = true;

    // Autoplay starts in a playing state, so show pause first.
    setVideoControlState(true);

    var player = new Vimeo.Player($videoIframe[0]);

    player.ready().then(function() {
      player.play().then(function() {
        $videoIframe.css('visibility', 'visible');
        $loadingElement.css('opacity', '0');
        $loadingElement.fadeOut(500); 
        setVideoControlState(true);
      }, function () {
        // If autoplay is blocked, keep controls in paused state.
        setVideoControlState(false);
      });
    });

      $playButton.off('click.videoControl').on('click.videoControl', function (e) {
        e.preventDefault();
        player.play().then(function () {
          setVideoControlState(true);
        });
      });

      $pauseButton.off('click.videoControl').on('click.videoControl', function (e) {
        e.preventDefault();
        player.pause().then(function () {
          setVideoControlState(false);
        });
      });

      player.on('play', function () {
        setVideoControlState(true);
      });

      player.on('pause', function () {
        setVideoControlState(false);
      });

    player.on('ended', function() {
        setVideoControlState(false);
        player.setCurrentTime(0).then(function() {
          player.play();
        })
    });
  }

  // Start with one visible button (autoplay expected).
  setVideoControlState(true);

  ensureVimeoApi(function () {
    $videoIframe.off('load.videoControl').on('load.videoControl', initVimeoControls);
    initVimeoControls();
  });
}

function initPromoVideo() {
  initLazyVimeoVideoModule({
    rootSelector: '.promo',
    iframeSelector: '.promo__video-container iframe',
    overlaySelector: '.promo__video-overlay',
    playButtonSelector: '.promo__video-control-btn--play',
    pauseButtonSelector: '.promo__video-control-btn--pause',
    hoverNamespace: 'promoHover',
    videoNamespace: 'promoVideo',
    coverNamespace: 'promoCover'
  });

  initLazyVimeoVideoModule({
    rootSelector: '.fifty-fifty',
    iframeSelector: '.fifty-fifty__video-container iframe',
    overlaySelector: '.fifty-fifty__video-overlay',
    playButtonSelector: '.fifty-fifty__video-control-btn--play',
    pauseButtonSelector: '.fifty-fifty__video-control-btn--pause',
    hoverNamespace: 'fiftyHover',
    videoNamespace: 'fiftyVideo',
    coverNamespace: 'fiftyCover'
  });
}

function initLazyVimeoVideoModule(config) {
  var $modules = $(config.rootSelector);
  if (!$modules.length) {
    return;
  }

  $modules.each(function (index) {
    var $module = $(this);
    var $iframe = $module.find(config.iframeSelector).first();
    var $overlay = $module.find(config.overlaySelector).first();
    var $playButton = $module.find(config.playButtonSelector).first();
    var $pauseButton = $module.find(config.pauseButtonSelector).first();

    if (!$iframe.length || !$playButton.length || !$pauseButton.length) {
      return;
    }

    var player = null;
    var playerInitialized = false;
    var iframeEl = $iframe[0];
    var hoverEventNamespace = config.hoverNamespace + index;
    var videoEventNamespace = config.videoNamespace + index;
    var coverEventNamespace = config.coverNamespace + index;

    coverModuleViewport(iframeEl, true);
    window.addEventListener('resize', function () {
      coverModuleViewport(iframeEl, true);
    });

    $module
      .off('mouseenter.' + hoverEventNamespace + ' mouseleave.' + hoverEventNamespace)
      .on('mouseenter.' + hoverEventNamespace, function () {
        $module.addClass('mouse-over-video');
      })
      .on('mouseleave.' + hoverEventNamespace, function () {
        $module.removeClass('mouse-over-video');
      });

    function setControlState(isPlaying) {
      $playButton.attr('aria-pressed', isPlaying ? 'false' : 'true');
      $pauseButton.attr('aria-pressed', isPlaying ? 'true' : 'false');
      $playButton.toggleClass('active', !isPlaying);
      $pauseButton.toggleClass('active', isPlaying);
    }

    function initPlayerIfNeeded() {
      if (playerInitialized || !(window.Vimeo && window.Vimeo.Player)) {
        return;
      }

      playerInitialized = true;
      player = new Vimeo.Player(iframeEl);

      player.on('play', function () {
        setControlState(true);
        if ($overlay.length) {
            $overlay.addClass('is-hidden');
        }
      });

      player.on('pause', function () {
        setControlState(false);
      });
    }

    function loadVideoAndPlay() {
      var videoSrc = iframeEl.getAttribute('data-src');
      var hasLoadedSource = videoSrc && iframeEl.getAttribute('src') === videoSrc;

      if (!hasLoadedSource && videoSrc) {
        $iframe.one('load.' + videoEventNamespace, function () {
	        if ($overlay.length) {
	          $overlay.addClass('is-zooming-out');
	        }
          coverModuleViewport(iframeEl, true);
          initPlayerIfNeeded();
          if (player) {
            player.play();
          }
        });
        iframeEl.setAttribute('src', videoSrc);
        return;
      }

      initPlayerIfNeeded();
      coverModuleViewport(iframeEl, true);
      if (player) {
        player.play();
      }
    }

    setControlState(false);

    $iframe.off('load.' + coverEventNamespace).on('load.' + coverEventNamespace, function () {
      coverModuleViewport(this, true);
    });

    $playButton.off('click.' + videoEventNamespace).on('click.' + videoEventNamespace, function (e) {
      e.preventDefault();
      ensureSharedVimeoApi(loadVideoAndPlay);
    });

    $pauseButton.off('click.' + videoEventNamespace).on('click.' + videoEventNamespace, function (e) {
      e.preventDefault();
      if (player) {
        player.pause();
      }
    });
  });
}

function ensureSharedVimeoApi(callback) {
  if (window.Vimeo && window.Vimeo.Player) {
    callback();
    return;
  }

  var existingScript = document.querySelector('script[data-vimeo-player-api="true"]');
  if (existingScript) {
    existingScript.addEventListener('load', callback);
    return;
  }

  var script = document.createElement('script');
  script.src = 'https://player.vimeo.com/api/player.js';
  script.async = true;
  script.setAttribute('data-vimeo-player-api', 'true');
  script.addEventListener('load', callback);
  document.body.appendChild(script);
}

function initModuleVideo() {
  var $modules = $('[data-module-video]');
  if (!$modules.length) {
    return;
  }

  $modules.each(function () {
    var moduleEl = this;
    var $module = $(moduleEl);
    var iframeEl = moduleEl.querySelector('iframe');
    var videoEl = moduleEl.querySelector('video');
    var $playButton = $module.find('.module-video__control-btn--play');
    var $pauseButton = $module.find('.module-video__control-btn--pause');
    var isFileVideo = !!(videoEl && !iframeEl);

    if ((!iframeEl && !videoEl) || !$playButton.length || !$pauseButton.length) {
      return;
    }

    var isCover = moduleEl.classList.contains('module-video--cover');
    var player = moduleEl._moduleVideoPlayer || null;
    var playerInitialized = !!player;
    var hoverNamespace = 'moduleVideoHover';
    var videoNamespace = 'moduleVideoControl';
    var coverNamespace = 'moduleVideoCover';

    function applyCover() {
      if (isCover && iframeEl) {
        coverModuleViewport(iframeEl, true);
      }
    }

    applyCover();

    if (!moduleEl._moduleVideoBound) {
      window.addEventListener('resize', applyCover);

      if (typeof ResizeObserver !== 'undefined' && isCover && iframeEl) {
        new ResizeObserver(applyCover).observe(moduleEl);
      }

      moduleEl._moduleVideoBound = true;
    }

    $module
      .off('mouseenter.' + hoverNamespace + ' mouseleave.' + hoverNamespace)
      .on('mouseenter.' + hoverNamespace, function () {
        $module.addClass('mouse-over-video');
      })
      .on('mouseleave.' + hoverNamespace, function () {
        $module.removeClass('mouse-over-video');
      });

    $module.find('.module-video__control')
      .off('click.' + videoNamespace)
      .on('click.' + videoNamespace, function (e) {
        e.stopPropagation();
      });

    function setControlState(isPlaying) {
      $playButton.attr('aria-pressed', isPlaying ? 'false' : 'true');
      $pauseButton.attr('aria-pressed', isPlaying ? 'true' : 'false');
      $playButton.toggleClass('active', !isPlaying);
      $pauseButton.toggleClass('active', isPlaying);
      $module.toggleClass('is-playing', isPlaying);
    }

    if (isFileVideo) {
      setControlState(!videoEl.paused && !videoEl.ended);

      $(videoEl)
        .off('play.' + videoNamespace + ' pause.' + videoNamespace + ' ended.' + videoNamespace)
        .on('play.' + videoNamespace, function () {
          setControlState(true);
        })
        .on('pause.' + videoNamespace + ' ended.' + videoNamespace, function () {
          setControlState(false);
        });

      $playButton.off('click.' + videoNamespace).on('click.' + videoNamespace, function (e) {
        e.preventDefault();
        e.stopPropagation();
        videoEl.play();
      });

      $pauseButton.off('click.' + videoNamespace).on('click.' + videoNamespace, function (e) {
        e.preventDefault();
        e.stopPropagation();
        videoEl.pause();
      });

      return;
    }

    function initPlayerIfNeeded() {
      if (player) {
        playerInitialized = true;
        return;
      }

      if (playerInitialized || !(window.Vimeo && window.Vimeo.Player)) {
        return;
      }

      playerInitialized = true;
      player = new Vimeo.Player(iframeEl);
      moduleEl._moduleVideoPlayer = player;

      player.on('play', function () {
        setControlState(true);
      });

      player.on('pause', function () {
        setControlState(false);
      });

      player.getPaused().then(function (paused) {
        setControlState(!paused);
      }).catch(function () {
        var src = iframeEl.getAttribute('src') || '';
        setControlState(/[?&]autoplay=1(?:&|$)/.test(src));
      });
    }

    var initialSrc = iframeEl.getAttribute('src') || '';
    setControlState(/[?&]autoplay=1(?:&|$)/.test(initialSrc));

    $(iframeEl).off('load.' + coverNamespace).on('load.' + coverNamespace, function () {
      applyCover();
      initPlayerIfNeeded();
    });

    ensureSharedVimeoApi(function () {
      initPlayerIfNeeded();
      applyCover();
    });

    $playButton.off('click.' + videoNamespace).on('click.' + videoNamespace, function (e) {
      e.preventDefault();
      e.stopPropagation();
      ensureSharedVimeoApi(function () {
        initPlayerIfNeeded();
        if (player) {
          player.play();
        }
      });
    });

    $pauseButton.off('click.' + videoNamespace).on('click.' + videoNamespace, function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (player) {
        player.pause();
      }
    });
  });
}

window.initModuleVideo = initModuleVideo;

function coverModuleViewport(element, scaleToParent) {
  if (!element) {
    return;
  }

  if (typeof scaleToParent === 'undefined') {
    scaleToParent = false;
  }

  var viewportWidth, viewportHeight;
  if (scaleToParent) {
    viewportWidth = element.parentElement.clientWidth;
    viewportHeight = element.parentElement.clientHeight;
  } else {
    viewportWidth = window.innerWidth;
    viewportHeight = window.innerHeight;
  }

  if (!viewportWidth || !viewportHeight) {
    return;
  }

  var elementWidth = parseFloat(element.getAttribute('width')) || 16;
  var elementHeight = parseFloat(element.getAttribute('height')) || 9;

  var viewportRatio = viewportHeight / viewportWidth;
  var videoRatio = elementHeight / elementWidth;

  var newWidth = (elementWidth / elementHeight) * viewportHeight;
  var newHeight = (elementHeight / elementWidth) * viewportWidth;

  if (viewportRatio > videoRatio) {
    element.style.height = viewportHeight + 'px';
    element.style.width = newWidth + 'px';
    element.style.left = '-' + (newWidth - viewportWidth) / 2 + 'px';
    element.style.top = '0';
  } else if (viewportRatio < videoRatio) {
    element.style.width = viewportWidth + 'px';
    element.style.height = newHeight + 'px';
    element.style.left = '0';
    element.style.top = '-' + (newHeight - viewportHeight) / 2 + 'px';
  } else {
    element.style.height = viewportHeight + 'px';
    element.style.width = viewportWidth + 'px';
    element.style.left = '0';
    element.style.top = '0';
  }
}

function initPriorOffCanvas() {
  var menuContainer = document.querySelector("#offCanvas");
  var menuToggleBtns = document.querySelectorAll(
    ".header__open-off-canvas, .off-canvas__close"
  );

  var bookingContainer = document.querySelector("#booking");
  var bookingToggleBtns = document.querySelectorAll(
    ".header__open-booking, .booking__close"
  );

  var states = {
    isActiveMenu: false,
    isActiveBooking: false,
    toggleMenu: function () {
      this.isActiveMenu = !this.isActiveMenu;
    },
    toggleBooking: function () {
      this.isActiveBooking = !this.isActiveBooking;
    },
  };

  handleOffCanvasMenu(menuContainer, menuToggleBtns, states);
  handleOffCanvasBooking(bookingContainer, bookingToggleBtns, states);

  function handleOffCanvasMenu(container, toggleBtns, states) {
    toggleBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        states.toggleMenu();
        slideToggle(states.isActiveMenu, container);
      });
    });
  }

  function handleOffCanvasBooking(container, toggleBtns, states) {
    toggleBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        states.toggleBooking();
        revealToggle(states.isActiveBooking, container);
      });
    });
  }

  var slideToggle = function (state, container) {
    if (!state) {
      container.style.transform = "translateX(-100%)";
    } else {
      container.style.transform = "translateX(0)";
    }
  };

  var revealToggle = function (state, container) {
    if (!state) {
      container.classList.remove('active')
    } else {
      container.classList.add('active')
    }
  };
}
